/*
 * Иконки. Геометрия в стиле Lucide (лицензия ISC) — штриховые, сетка 24×24,
 * толщина линии 2, скруглённые концы.
 *
 * Хранятся строками с содержимым <svg>, а не отдельными компонентами:
 * набор большой, а каждый файл-компонент добавлял бы накладные расходы
 * на импорт ради одной строки разметки.
 *
 * Цвет наследуется через `stroke="currentColor"` — иконка красится
 * цветом текста родителя и автоматически подходит обеим темам.
 */

export const ICONS = {
	smartphone: '<rect x="6" y="2" width="12" height="20" rx="2"/><path d="M11 18h2"/>',
	sliders:
		'<path d="M3 6h4m4 0h10M3 12h10m4 0h4M3 18h4m4 0h10"/><circle cx="9" cy="6" r="2"/><circle cx="15" cy="12" r="2"/><circle cx="9" cy="18" r="2"/>',
	car: '<path d="m5 6-2 7v5h18v-5l-2-7H5Z"/><path d="M3 13h18M5 18v3m14-3v3M7 16h1m8 0h1"/>',
	home: '<path d="m3 10 9-7 9 7v11h-7v-7h-4v7H3V10Z"/>',
	wrench: '<path d="M14 6a5 5 0 0 0-6 6L3 17a3 3 0 0 0 4 4l5-5a5 5 0 0 0 6-6l-3 3-4-4 3-3Z"/>',
	/* --- Навигация ------------------------------------------------------ */
	chats:
		'<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>',
	calls:
		'<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>',
	contacts:
		'<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
	mail: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 7L2 7"/>',
	star: '<path d="m12 2 3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14 2 9.27l6.91-1.01z"/>',
	cloud:
		'<path d="M17.5 19H6a4 4 0 0 1-.4-7.98A6.5 6.5 0 0 1 18 9a5 5 0 0 1-.5 10z"/><path d="M12 12v6M9 15h6"/>',
	ban: '<circle cx="12" cy="12" r="9"/><path d="m5.6 5.6 12.8 12.8"/>',
	settings:
		'<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
	search: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>',
	eye: '<path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/><circle cx="12" cy="12" r="3"/>',
	'eye-off':
		'<path d="m2 2 20 20"/><path d="M6.71 6.71C4.26 8.16 2.8 10.48 2 12c1.73 3.39 5.44 6 10 6 1.27 0 2.46-.2 3.54-.55"/><path d="M10.73 5.08A10.4 10.4 0 0 1 12 5c4.56 0 8.27 2.61 10 6-.5.98-1.22 2.04-2.15 2.98"/><path d="M14.12 14.12a3 3 0 0 1-4.24-4.24"/>',

	/* --- Каталог сервисов ----------------------------------------------- */
	candlesticks: '<path d="M6 3v18M3 8h6v7H3zM18 3v18M15 6h6v6h-6zM12 3v18M9 12h6v6H9z"/>',
	/* Штанга: гриф, два внутренних блина повыше и два внешних пониже. */
	dumbbell: '<path d="M6.5 12h11"/><path d="M6.5 7.5v9M17.5 7.5v9"/><path d="M3 9.5v5M21 9.5v5"/>',
	/** Мишень — у цели на день. */
	target:
		'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="5"/><circle cx="12" cy="12" r="1"/>',
	/** Кубок — у итога закрытой цели. */
	trophy:
		'<path d="M7 4h10v5a5 5 0 0 1-10 0z"/><path d="M7 6H5a2 2 0 0 0 0 4h2M17 6h2a2 2 0 0 1 0 4h-2"/><path d="M12 14v3M9 20h6M10 17h4"/>',
	'shopping-bag':
		'<path d="M6 8V6a6 6 0 0 1 12 0v2"/><path d="M4 8h16l1 13H3L4 8z"/><path d="M9 11v1M15 11v1"/>',
	briefcase:
		'<rect x="2" y="7" width="20" height="13" rx="2"/><path d="M8 7V4h8v3M2 12h20M10 12v2h4v-2"/>',
	calendar:
		'<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/><path d="m12 13 1 2 2 .3-1.5 1.5.4 2.2-1.9-1-1.9 1 .4-2.2L9 15.3l2-.3z"/>',
	gamepad:
		'<path d="M7 8h10a5 5 0 0 1 4.8 6.4l-1.1 3.7a2.5 2.5 0 0 1-4.2 1l-2-2.1h-5l-2 2.1a2.5 2.5 0 0 1-4.2-1l-1.1-3.7A5 5 0 0 1 7 8z"/><path d="M7 12v4M5 14h4M16 13h.01M19 15h.01"/>',
	bot: '<rect x="4" y="7" width="16" height="13" rx="4"/><path d="M12 3v4M9 3h6M8 13h.01M16 13h.01M8 17h8M4 11H2M22 11h-2"/>',
	music:
		'<path d="M9 18V5l11-2v13"/><path d="M9 9l11-2"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/>',
	'graduation-cap':
		'<path d="m2 9 10-5 10 5-10 5L2 9z"/><path d="M6 11.5V16c3.5 3 8.5 3 12 0v-4.5M22 9v7"/>',
	wallet:
		'<path d="M4 5h14a2 2 0 0 1 2 2v13H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/><path d="M2 8h18M15 12h7v5h-7a2.5 2.5 0 0 1 0-5z"/>',
	heart:
		'<path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8z"/><path d="M7 12h3l1.3-3 2.2 6 1.2-3H18"/>',
	newspaper:
		'<path d="M4 4h14v16H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><path d="M18 8h4v10a2 2 0 0 1-2 2h-2M7 8h8M7 12h8M7 16h5"/>',

	/* --- Действия ------------------------------------------------------- */
	plus: '<path d="M12 5v14M5 12h14"/>',
	close: '<path d="M18 6 6 18M6 6l12 12"/>',
	eraser:
		'<path d="m7 21-4.3-4.3a2.4 2.4 0 0 1 0-3.4l9.6-9.6a2.4 2.4 0 0 1 3.4 0l5.6 5.6a2.4 2.4 0 0 1 0 3.4L13 21"/><path d="M22 21H7"/><path d="m5 11 9 9"/>',
	check: '<path d="M20 6 9 17l-5-5"/>',
	'check-double': '<path d="M18 6 7 17l-4-4"/><path d="m22 8-8.5 8.5"/>',
	clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
	signal: '<path d="M5 19v-2M9.5 19v-5M14.5 19V9M19 19V4"/>',
	send: '<path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4 20-7z"/>',
	attach:
		'<path d="M21.44 11.05 12.25 20.24a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>',
	emoji:
		'<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><path d="M9 9h.01M15 9h.01"/>',
	microphone:
		'<path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><path d="M12 19v3"/>',
	'microphone-off':
		'<path d="M2 2l20 20"/><path d="M9 9v3a3 3 0 0 0 5.12 2.12"/><path d="M15 9.34V5a3 3 0 0 0-5.94-.6"/><path d="M19 10v2a7 7 0 0 1-.11 1.23"/><path d="M5 10v2a7 7 0 0 0 12 5"/><path d="M12 19v3"/>',
	camera: '<path d="m23 7-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>',
	'camera-off':
		'<path d="M2 2l20 20"/><path d="M16 16v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5 0h4a2 2 0 0 1 2 2v3l5-3v10"/>',
	'screen-share':
		'<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><path d="M12 12V7m0 0-2.5 2.5M12 7l2.5 2.5"/>',
	record:
		'<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4" fill="currentColor" stroke="none"/>',
	/* Огонёк исчезающего фото: внешнее пламя и язычок внутри. */
	flame:
		'<path d="M12 22a7 7 0 0 0 7-7c0-4-3-6.5-4.5-10-1 2-2 3-3.5 4C9 7.5 8 5 8 5c-2 2.5-3 5.5-3 10a7 7 0 0 0 7 7Z"/><path d="M12 22a3 3 0 0 0 3-3c0-1.8-1.5-2.6-3-4.5-1.5 1.9-3 2.7-3 4.5a3 3 0 0 0 3 3Z"/>',
	hangup:
		'<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/><path d="M2 2l20 20"/>',

	/* --- Звонки: направление -------------------------------------------- */
	'call-incoming': '<path d="M16 2v6h6"/><path d="M22 2 16 8"/><path d="M13 21a9 9 0 0 1-9-9"/>',
	'call-outgoing': '<path d="M22 8V2h-6"/><path d="M16 8 22 2"/><path d="M13 21a9 9 0 0 1-9-9"/>',
	'call-missed': '<path d="M22 2 16 8"/><path d="M16 2h6v6"/><path d="M13 21a9 9 0 0 1-9-9"/>',

	/* --- Стрелки и раскрытие -------------------------------------------- */
	'chevron-left': '<path d="m15 18-6-6 6-6"/>',
	'chevron-right': '<path d="m9 18 6-6-6-6"/>',
	'chevron-down': '<path d="m6 9 6 6 6-6"/>',
	'chevron-up': '<path d="m18 15-6-6-6 6"/>',
	'arrow-left': '<path d="M19 12H5"/><path d="m12 19-7-7 7-7"/>',
	'arrow-down': '<path d="M12 5v14"/><path d="m19 12-7 7-7-7"/>',

	/* --- Меню и списки --------------------------------------------------- */
	'more-vertical':
		'<circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/>',
	'more-horizontal':
		'<circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>',
	menu: '<path d="M3 12h18M3 6h18M3 18h18"/>',

	/* --- Работа с сообщениями -------------------------------------------- */
	reply: '<path d="M9 17l-6-6 6-6"/><path d="M21 18v-2a4 4 0 0 0-4-4H3"/>',
	forward: '<path d="M15 17l6-6-6-6"/><path d="M3 18v-2a4 4 0 0 1 4-4h14"/>',
	edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>',
	copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>',
	trash:
		'<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M10 11v6M14 11v6"/>',
	// Закладка — значок «Избранного», чата с самим собой.
	bookmark: '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>',
	pin: '<path d="M12 17v5"/><path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/>',
	poll: '<path d="M4 5h16M4 12h16M4 19h16"/><circle cx="7" cy="5" r="2" fill="var(--background-surface)"/><circle cx="14" cy="12" r="2" fill="var(--background-surface)"/><circle cx="10" cy="19" r="2" fill="var(--background-surface)"/>',
	'bell-off':
		'<path d="M2 2l20 20"/><path d="M18.63 13A17.9 17.9 0 0 1 18 8"/><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"/><path d="M18 8a6 6 0 0 0-9.33-5"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>',

	/* --- Медиа ----------------------------------------------------------- */
	play: '<path d="M6 3l14 9-14 9V3z"/>',
	pause:
		'<rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/>',
	image:
		'<rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/>',
	file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/>',
	download:
		'<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5"/><path d="M12 15V3"/>',
	/* Обновить: круговая стрелка. Раньше на этой кнопке стояла «скачать», и
	   значок обещал не то, что кнопка делает. */
	refresh: '<path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/>',

	/* --- Железо ------------------------------------------------------------ */
	cpu: '<rect x="6" y="6" width="12" height="12" rx="2"/><rect x="9.5" y="9.5" width="5" height="5" rx="1"/><path d="M9 2v3M15 2v3M9 19v3M15 19v3M2 9h3M2 15h3M19 9h3M19 15h3"/>',
	memory:
		'<rect x="3" y="7" width="18" height="10" rx="2"/><path d="M7 11v3M11 11v3M15 11v3M19 11v3M6 17v3M18 17v3"/>',
	disk: '<ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v12c0 1.66 3.58 3 8 3s8-1.34 8-3V6"/><path d="M4 12c0 1.66 3.58 3 8 3s8-1.34 8-3"/>',
	server:
		'<rect x="3" y="4" width="18" height="6" rx="2"/><rect x="3" y="14" width="18" height="6" rx="2"/><path d="M7 7h.01M7 17h.01M11 7h6M11 17h6"/>',

	/* --- Типы чатов -------------------------------------------------------- */
	/* Группа — трое рядом; канал — рупор: вещание в одну сторону. */
	group:
		'<circle cx="9" cy="8" r="3"/><path d="M2 20v-1.5A4.5 4.5 0 0 1 6.5 14h5a4.5 4.5 0 0 1 4.5 4.5V20"/><path d="M17 5.13a3 3 0 0 1 0 5.74"/><path d="M22 20v-1.5a4.5 4.5 0 0 0-3.5-4.39"/>',
	channel:
		'<path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z"/><path d="M16 8.5a4 4 0 0 1 0 7"/><path d="M19 5.5a8 8 0 0 1 0 13"/>',
	/* Не контакт — тот же человек, но перечёркнутый. */
	'user-off':
		'<circle cx="12" cy="8" r="4"/><path d="M4 21v-1a6 6 0 0 1 6-6h4a6 6 0 0 1 5.2 3"/><path d="m3 3 18 18"/>',

	/* --- Папки и настройки ------------------------------------------------ */
	folder:
		'<path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"/>',
	'folder-plus':
		'<path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z"/><path d="M12 11v6M9 14h6"/>',
	shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>',
	devices:
		'<rect x="2" y="4" width="13" height="10" rx="1"/><path d="M6 18h5M8.5 14v4"/><rect x="17" y="8" width="5" height="12" rx="1"/>',
	keyboard:
		'<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8"/>',
	help: '<circle cx="12" cy="12" r="10"/><path d="M9.1 9.5a3 3 0 0 1 5.8 1c0 2-2.9 2.5-2.9 4"/><path d="M12 17.5h.01"/>',
	bell: '<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.7 21a2 2 0 0 1-3.4 0"/>',
	palette:
		'<circle cx="13.5" cy="6.5" r="1"/><circle cx="17.5" cy="10.5" r="1"/><circle cx="8.5" cy="7.5" r="1"/><circle cx="6.5" cy="12.5" r="1"/><path d="M12 2a10 10 0 0 0 0 20 2.5 2.5 0 0 0 2-4 2.5 2.5 0 0 1 2-4h2a4 4 0 0 0 4-4 10 10 0 0 0-10-8z"/>',
	/* Ухватка для перетаскивания: две линии, как у переставляемых строк. */
	grip: '<path d="M4 9h16M4 15h16"/>',
	link: '<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7"/><path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7"/>',
	/*
	 * Общая иконка «поделиться» для всех внешних сервисов. Фирменные знаки
	 * Telegram, VK и WhatsApp не воспроизводим — сервис называется словами
	 * в подписи строки, и этого достаточно, чтобы понять, куда ведёт кнопка.
	 */
	share:
		'<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><path d="M16 6l-4-4-4 4"/><path d="M12 2v13"/>',
	'photo-camera':
		'<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.5l1.8-3h7.4l1.8 3H21a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>',

	/*
	 * Знак подтверждённого аккаунта. Рисуется заливкой, а не обводкой:
	 * при 16 пикселях штриховая версия превращается в кашу.
	 * Использовать с `filled`.
	 */
	verified:
		'<path d="M12 1.6l2.4 2.1 3.2-.3.7 3.1 2.8 1.6-1.4 2.9 1.4 2.9-2.8 1.6-.7 3.1-3.2-.3L12 22.4l-2.4-2.1-3.2.3-.7-3.1L2.9 16l1.4-2.9L2.9 10l2.8-1.6.7-3.1 3.2.3z"/><path d="M8.6 12.2l2.3 2.3 4.5-4.5" stroke="var(--background-surface)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>',

	/*
	 * Знак подписки ANDRESOT Premium: пухлая звезда с облачком разговора
	 * внутри и зелёной искрой у нижнего луча.
	 *
	 * Облачко — настоящая дырка (`fill-rule="evenodd"`), а не залитая цветом
	 * фона фигура. Знак ставится и на обычный фон списка, и на градиент
	 * карточки Premium: заплатка одного цвета на втором была бы видна сразу.
	 *
	 * Искра — единственная часть с собственным цветом; остальное берёт
	 * `currentColor`, поэтому знак красится вместе с текстом. Использовать
	 * с `filled`.
	 */
	premium:
		'<path fill-rule="evenodd" d="M11.16 2.7Q12 1 12.84 2.7L14.39 5.85Q15.06 7.19 16.54 7.41L20.01 7.91Q21.89 8.19 20.53 9.51L18.02 11.96Q16.95 13.01 17.2 14.49L17.79 17.94Q18.11 19.81 16.43 18.93L13.33 17.3Q12 16.6 10.67 17.3L7.57 18.93Q5.89 19.81 6.21 17.94L6.8 14.49Q7.05 13.01 5.98 11.96L3.47 9.51Q2.11 8.19 3.99 7.91L7.46 7.41Q8.94 7.19 9.61 5.85ZM12 6.7a3.3 3.3 0 1 1-2.2 5.76l-1.83.9a.32.32 0 0 1-.43-.42l.85-1.83A3.3 3.3 0 0 1 12 6.7Z"/><path d="M18.75 14.9q.62 1.9 2.5 2.5-1.88.6-2.5 2.5-.62-1.9-2.5-2.5 1.88-.6 2.5-2.5Z" fill="var(--premium-spark)"/>',

	/* --- Истории ---------------------------------------------------------- */
	'story-add': '<circle cx="12" cy="12" r="9"/><path d="M12 8.5v7M8.5 12h7"/>',
	'hand-raised':
		'<path d="M18 11V6.5a1.5 1.5 0 0 0-3 0V11"/><path d="M15 10.5V4.5a1.5 1.5 0 0 0-3 0V11"/><path d="M12 10.5V5.5a1.5 1.5 0 0 0-3 0V13"/><path d="M9 12.5v-2a1.5 1.5 0 0 0-3 0V15a7 7 0 0 0 7 7h1a7 7 0 0 0 7-7v-4a1.5 1.5 0 0 0-3 0"/>',

	/* --- Прочее ---------------------------------------------------------- */
	user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
	lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
	info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/>',
	qr: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3h-3zM21 14v3M21 21h-7"/>',
	globe:
		'<circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
	maximize:
		'<path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/>',
	minimize:
		'<path d="M8 3v3a2 2 0 0 1-2 2H3M21 8h-3a2 2 0 0 1-2-2V3M3 16h3a2 2 0 0 1 2 2v3M16 21v-3a2 2 0 0 1 2-2h3"/>',
	grid: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
	'speaker-view':
		'<rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="12" cy="10" r="3"/><path d="M7 18c.8-2.3 2.5-3.5 5-3.5s4.2 1.2 5 3.5"/>',
	volume:
		'<path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>',
	'volume-off': '<path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m22 9-6 6M16 9l6 6"/>',
	logout:
		'<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5"/><path d="M21 12H9"/>'
} as const;

export type IconName = keyof typeof ICONS;
